import { LegalLayout, Section, Fill, L } from "@/pages/legal/LegalLayout";

export default function MentionsLegales() {
  return (
    <LegalLayout title="Mentions légales" testId="legal-mentions-page">
      <Section title="Éditeur du site">
        <ul>
          <li>Nom ou raison sociale : <Fill>nom de l'éditeur / société</Fill></li>
          <li>Forme juridique et capital social : <Fill>ex. SAS au capital de … €, ou entrepreneur individuel</Fill></li>
          <li>Adresse du siège : <Fill>adresse postale complète</Fill></li>
          <li>SIRET / RCS : <Fill>numéro SIRET et ville du RCS</Fill></li>
          <li>N° de TVA intracommunautaire : <Fill>numéro de TVA, si applicable</Fill></li>
          <li>Directeur ou directrice de la publication : <Fill>nom du responsable de la publication</Fill></li>
          <li>Contact : <a href="mailto:contact@lismoi.org" data-testid="legal-contact-email">contact@lismoi.org</a> · <Fill>téléphone</Fill></li>
        </ul>
      </Section>
      <Section title="Hébergement">
        <ul>
          <li>Hébergeur de l'application : <Fill>nom, adresse et téléphone de l'hébergeur (plateforme Emergent, à confirmer)</Fill></li>
          <li>Base de données : <Fill>MongoDB Atlas (MongoDB, Inc.), région d'hébergement à confirmer</Fill></li>
        </ul>
      </Section>
      <Section title="Propriété intellectuelle">
        <p>Les textes, illustrations, logos et éléments graphiques du site sont protégés par le droit d'auteur. Toute reproduction sans autorisation est interdite. Les histoires créées avec le générateur sont réservées à un usage privé et familial (voir les <L to="/cgu-cgv">CGU / CGV</L>).</p>
      </Section>
      <Section title="Médiation de la consommation">
        <p>En cas de litige, après une réclamation écrite restée sans réponse, le consommateur peut recourir gratuitement au médiateur : <Fill>nom, site web et adresse du médiateur de la consommation</Fill>. Plateforme européenne de règlement en ligne des litiges : ec.europa.eu/consumers/odr.</p>
      </Section>
      <Section title="Données personnelles">
        <p>Voir notre <L to="/confidentialite">Politique de confidentialité</L>.</p>
      </Section>
    </LegalLayout>
  );
}
